// @flow

import { hpfetchWithoutContentType } from '../util';
import type { agreementType } from '../../types';

export const uploadSingle = (id: number, agreement: agreementType) => {
  const endpoint = `purchases/${id}/agreements/`;
  const form = new FormData();

  Object.entries(agreement).forEach(([key, value]) => {
    // $FlowFixMe
    form.append(key, value);
  });

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
    body: form,
  });
};
